import { Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { format, parseISO } from "date-fns";
import { Fragment } from "react";

function NaturalDisastersPreview({ items }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierPhysicalRiskQuestionnaire"
  });

  return (
    <Grid templateColumns={"repeat(3, 1fr)"} gap={2}>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.naturalDisasters")}
        </Heading>
      </GridItem>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.date")}
        </Heading>
      </GridItem>
      <GridItem>
        <Heading marginBlock="1" align="left" size="xs">
          {t("inputs.eventDescription")}
        </Heading>
      </GridItem>
      {items.map(item => {
        return <Fragment key={item.id}>
          <GridItem>
            <Text
              fontSize="sm"
              whiteSpace="break-spaces"
            >
              {item.type && item.type !== "" ? t(`naturalDisasterOptions.${item.type}`) : ""}
            </Text>
          </GridItem>
          <GridItem>
            <Text
              fontSize="sm"
              whiteSpace="break-spaces"
            >
              {item.date && item.date !== "" ? format(parseISO(item.date), "d MMM yyyy") : ""}
            </Text>
          </GridItem>
          <GridItem>
            <Text
              fontSize="sm"
              whiteSpace="break-spaces"
            >
              {item.description && item.description !== "" ? item.description : ""}
            </Text>
          </GridItem>
        </Fragment>;
      })}
    </Grid>
  );
}

export default NaturalDisastersPreview;